import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Cards from '../pages/cards/cards';
import OrderPrice from '../pages/orderPrice/orderPrice';
import Projects from '../pages/projects/projects';

export default function DefaultRoutes(){
    return (
        <BrowserRouter>
            <Routes >
                <Route path="/" Component={Cards} />
                <Route path="/orderPrice/:key" Component={OrderPrice} />
                <Route path="/orderPrice" Component={OrderPrice} />
                <Route path="/projects/:key" Component={Projects} />
            </Routes>
        </BrowserRouter>
    );
}